import React, { Fragment } from "react";

export default (
  <>
    <path d="M23.16409 2.97968c-1.00532-.86382-2.5207-.74912-3.38451.2562L9.02691 15.74987l-4.99935-4.61351c-.97397-.89897-2.49243-.83803-3.39125.13608-.89897.97397-.83803 2.49243.13608 3.39125l6.82659 6.29998c.47856.4418 1.11621.66987 1.7663.63237.65024-.03765 1.25713-.33794 1.68164-.83188L23.42028 6.3642c.86382-1.00532.74912-2.5207-.25619-3.38452z" />
  </>
);
